import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedCompanyMappingService } from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '@wealthlane/api-services/wealthlane-award-service';

interface MutationPayload {
  payload: any;
  id: string;
}

const usePutAllowedMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse,
  unknown,
  MutationPayload,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ payload, id }: MutationPayload) => {
      return await handleRequest(
        AllowedCompanyMappingService.putApiIdentityApiAppAllowedCompanyMapping(id, payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null) {
          toast.success(<ToastComponent label='Success' message={`Company Mapping Edited.`} />);
          await queryClient.invalidateQueries('getAllAllowedCompanyMappings');
        }
        onClose && onClose();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutAllowedMapping;
